import { extractChatInfo } from '../../../utils';
import styles from '../css/ConversationCard.module.css';

function ConversationCard({ chat, isChatSelected }) {
  const user = extractChatInfo(chat);

  // Process last message for display
  const lastMessageText = user.lastMessage
    ? user.lastMessage.length > 50
      ? `${user.lastMessage.substring(0, 47)}...`
      : user.lastMessage
    : chat?.last_message?.file_url
    ? 'File sent'
    : 'No messages yet';

  // Process timestamp (fallback if user.lastMessageTime is empty)
  const lastMessageTime = user.lastMessageTime || (
    chat?.last_message?.timestamp
      ? new Date(chat.last_message.timestamp).toLocaleTimeString([], {
          hour: '2-digit',
          minute: '2-digit',
        })
      : ''
  );

  // Add sender prefix for group chats
  const isGroupChat = chat?.dm_info?.members?.length > 1;
  const displayMessage = isGroupChat && chat?.last_message?.sender_name && user.lastMessage
    ? `${chat.last_message.sender_name}: ${lastMessageText}`
    : lastMessageText;

  return (
    <div
      className={`${styles.conversationCardContainer} ${
        isChatSelected ? styles.selectedChat : ''
      } d-flex align-items-center p-3 border-bottom`}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          document.getElementById(`chat-${chat.id}`).click();
        }
      }}
      aria-label={`Conversation with ${user.name}, last message: ${displayMessage}`}
      id={`chat-${chat.id}`}
    >
      <div className={`${styles.image} rounded-pill position-relative`}>
        <img
          className={styles.profilePic}
          src={user.imageUrl}
          alt={`${user.name}'s profile`}
        />
        {/* Green online indicator for single user chats */}
        {!isGroupChat && chat?.dm_info?.members[0]?.is_online && (
          <span className={`${styles.onlineIndicator} bg-success rounded-circle`}></span>
        )}
      </div>
      <div className="d-flex justify-content-between w-100 ms-3">
        <div className="d-flex justify-content-center flex-column">
          <p className={`${styles.name} m-0 fw-bold`}>{user.name}</p>
          <p className={`${styles.messageDescription} m-0 text-secondary`}>
            {displayMessage}
          </p>
        </div>
        {lastMessageTime && (
          <div>
            <p className={`${styles.lastMessageTime} m-0 text-muted`}>
              {lastMessageTime}
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default ConversationCard;